import {fabric} from 'fabric';
import './video';

fabric.UYOImage = fabric.util.createClass(fabric.Image, {
  type: 'uYOImage',
  isError: false,
});

fabric.UYOVideo = fabric.util.createClass(fabric.Video, {
  type: 'uYOImage',
  isError: false,

  initialize(src, options = {}) {
    // Call the parent (fabric.Video) initialize
    this.callSuper('initialize', src, options);

    const videoElement = this.getElement();
    videoElement.preload = 'metadata';

    const updateDimensions = () => {
      if (videoElement.videoWidth && videoElement.videoHeight) {
        this.set({
          width: videoElement.videoWidth,
          height: videoElement.videoHeight,
        });
        if (this.canvas) {
          this.canvas.renderAll();
        }
      }
    };

    // Listen for metadata to update dimensions
    videoElement.addEventListener('loadedmetadata', () => {
      updateDimensions();
    });

    // Log errors if any
    videoElement.addEventListener('error', (err) => {
      evite.error('Video failed to load metadata:', err);
    });

    // Attempt to play once loaded
    setTimeout(() => {
      const playPromise = videoElement.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch((err) => {
          evite.warn('Video play was prevented:', err);
        });
      }
    }, 100);
  },
});

fabric.UYOVideo.fromObject = ({src, ...object}, callback) => {
  const video = new fabric.UYOVideo(src, object);
  callback?.(video, false);
};
// Updated load function to handle both images and videos
const loadMedia = (url, callback, options = {}) => {
  const lowerUrl = url?.toLowerCase() || '';
  const isVideo =
    lowerUrl.endsWith('.mp4') || lowerUrl.endsWith('.webm') || lowerUrl.endsWith('.ogg');

  if (isVideo) {
    // Create a fabric.Video object
    const video = new fabric.UYOVideo(url, options);
    // Assign an id if needed
    if (!video.id) {
      // eslint-disable-next-line no-underscore-dangle
      const originalObject = video._originalObject || video.toObject();
      video.id = `${originalObject.left}${originalObject.top}${originalObject.height}${originalObject.width}`;
    }

    callback?.(video);
  } else {
    // Handle image as before
    fabric.util.loadImage(
      url,
      (img, isError) => {
        const uyoImage = new fabric.UYOImage(img, {...options, isError});
        if (!uyoImage.id) {
          // eslint-disable-next-line no-underscore-dangle
          const originalObject = uyoImage._originalObject || uyoImage.toObject();
          uyoImage.id = `${originalObject.left}${originalObject.top}${originalObject.height}${originalObject.width}`;
        }

        if (options?.clipPath && options.clipPath.type) {
          const Klass = fabric.util.getKlass(options.clipPath.type, 'fabric');
          if (Klass) {
            uyoImage.clipPath = new Klass(options.clipPath);
          }
        }
        callback?.(uyoImage);
      },
      null,
      'anonymous'
    );
  }
};

fabric.UYOImage.fromURL = loadMedia;
fabric.UYOImage.fromObject = (object, callback) => loadMedia(object.src, callback, object);
